module.exports = "../images/northern-pike@2x.jpg?v=a5fc614";